export const CategoryTypes = {
  Deals: 'deals',
  Events: 'events',
  Jobs: 'jobs',
  News: 'news',
};
